import React, { FC } from 'react';
import { createPictureFactory } from '@funtech-int/yango-shared';

import styles from './PersonTitle.module.css';

const pictureFactory = createPictureFactory({
    fallback: {
        srcSet: {
            '1x': '68x102',
            '2x': '136x204',
        },
        src: '68x102',
    },
});

interface PersonTitleProps {
    name: string;
    poster?: string;
}

export const PersonTitle: FC<PersonTitleProps> = ({ name, poster }) => {
    const { img } = pictureFactory({
        fallbackUrl: poster,
    });

    return (
        <div className={styles.root}>
            {poster && <img className={styles.img} src={img.src} srcSet={img.srcSet} alt={name} />}
            <h1 className={styles.title}>{name}</h1>
        </div>
    );
};
